/**
 * AltStamp Class
 */
export class AltStamp {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.allBlocks = document.querySelectorAll( containerEl );
		if ( ! this.allBlocks || this.allBlocks.length === 0 ) {

			return false;

		}

		this.init();

	}

	/**
	 * Init
	 *
	 * @return {void}
	 */
	init() {

		if ( this.allBlocks.length > 0 ) {

			this.allBlocks.forEach( ( block ) => {

				const stamps = block.querySelectorAll( '.b-stamp' );

				if ( stamps ) {

					stamps.forEach( ( el ) => {

						const newDiv = document.createElement( "div" );
						newDiv.classList.add( `js-stamp-alt` );

						const img = el.querySelector( "img" );
						newDiv.innerHTML = img.alt;

						el.appendChild( newDiv );

						const newDivHeight = newDiv.getBoundingClientRect().height;
						el.style.height =`${el.getBoundingClientRect().height + newDivHeight + 16}px`;

					} )

				}

			} );

		}

	}

}
